import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits.js";
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module horizontal-line/horizontalline
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import HorizontalLineEditing from './horizontallineediting';
import HorizontalLineUI from './horizontallineui';

/**
 * The horizontal line feature.
 *
 * It provides the possibility to insert a horizontal line into the rich-text editor.
 *
 * For a detailed overview, check the {@glink features/horizontal-line Horizontal line feature} documentation.
 *
 * @extends module:core/plugin~Plugin
 */
var HorizontalLine = /*#__PURE__*/function (_Plugin) {
  function HorizontalLine() {
    _classCallCheck(this, HorizontalLine);
    return _callSuper(this, HorizontalLine, arguments);
  }
  _inherits(HorizontalLine, _Plugin);
  return _createClass(HorizontalLine, null, [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [HorizontalLineEditing, HorizontalLineUI];
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "pluginName",
    get: function get() {
      return 'HorizontalLine';
    }
  }]);
}(Plugin);
export { HorizontalLine as default };